<script lang="ts">
	let { showModal = $bindable(false), children } = $props();

	let dialog: HTMLDialogElement;

	$effect(() => {
		if (dialog && showModal) dialog.showModal();
	});

	$effect(() => {
		if (dialog && !showModal && dialog.open) dialog.close();
	});
</script>

<dialog
	bind:this={dialog}
	onclose={() => (showModal = false)}
	onkeydown={(e) => e.target === dialog && dialog.close()}
	class="modal"
>
	<div class="close" onclick={() => dialog.close()} onkeydown={() => dialog.close()} role="button" aria-label="sluit" tabindex="0"></div>
	{@render children?.()}
</dialog>

<style>
	.modal {
		max-width: 50ch;
		max-height: 80%;
		padding: 2em 1em;
		border: 0;
		border-radius: var(--br);
		box-shadow: 0 0 rgb(0 0 0 / 0.3);
	}
	.modal > * {
		margin: 0 0 0.5rem 0;
	}
	.modal::backdrop {
		background: rgb(0 0 0 / 0.4);
	}
	.close::before {
		content: '×';
		background: var(--clr-bg-200);
		color: var(--clr-fg-200);
		position: absolute;
		top: 0;
		right: 0;
		width: 40px;
		height: 40px;
		border-radius: var(--br);
		font-size: 25px;
		text-align: center;
		cursor: pointer;
	}
	.close:hover {
		opacity: 0.8;
	}
</style>
